/**
 * What someone sees when they open the app outside Shopify.
 *
 * Every screen here assumes a merchant who arrived through their Shopify
 * admin, and the API will not answer without a session token only App Bridge
 * can mint. Rendered directly the app is a shell that can never load anything,
 * which looks broken rather than closed — so it says plainly where to go.
 *
 * It used to ask for the store domain and send that to /shopify/install.
 * App Store requirement 2.3.1 forbids it: an install must begin on a Shopify
 * surface, and the app must not request manual entry of a myshopify.com
 * domain anywhere in the install or configuration flow. The two places to
 * send someone are therefore the Admin, if the app is already installed, and
 * the App Store listing, if it is not — and from either one the shop arrives
 * in the session token rather than from a text field.
 */
const LISTING_URL = 'https://apps.shopify.com/synce-bridge'
const ADMIN_APPS_URL = 'https://admin.shopify.com/apps'

export default function OpenInShopify() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', padding: 24, background: 'var(--bg)' }}>
      <div className="card" style={{ maxWidth: 460, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: 15, fontWeight: 650, marginBottom: 8 }}>
          Open SyncE Bridge from your Shopify admin
        </div>
        <p style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.6, marginBottom: 18 }}>
          This app runs inside Shopify. Open it from <b>Apps</b> in your Shopify admin,
          and everything will be signed in already.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <a className="btn btn-primary" href={ADMIN_APPS_URL} target="_top" rel="noopener">
            Go to Shopify admin
          </a>
          <a className="btn" href={LISTING_URL} target="_top" rel="noopener">
            View listing
          </a>
        </div>
        <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 14 }}>
          Not installed yet? Install SyncE Bridge from the Shopify App Store.
        </div>
      </div>
    </div>
  )
}
